import {
  useGetWarrantyClaimDetailsQuery,
  useLazyGetNewWarrantyClaimsCountQuery,
} from '@api/warranty.api';
import {
  BlockContainer,
  LoadingError,
  WarrantyClaimProvider,
  WarrantyDetailsForm,
  WarrantyDetailsHeader,
} from '@components';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@hooks';
import { getSpecialPage } from '@store/app/app.slice';
import { useEffect, useMemo } from 'react';
import { WarrantyDetailsLoadingSkeleton } from './WarrantyDetailsLoadingSkeleton';
type WarrantyDetailsProps = {
  title?: string;
};

export const WarrantyDetailsBlock: React.FC<WarrantyDetailsProps> = ({
  title,
}: WarrantyDetailsProps) => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const pathname = location.pathname;
  const detailPathname = useAppSelector(getSpecialPage('warrantyDetailsPage')) as string;
  const id = urlParams.get('id');
  const { currentData, isLoading, isError, isFetching, isSuccess } =
    useGetWarrantyClaimDetailsQuery(id || '', {
      skip: !id,
    });

  const data = useMemo(() => currentData?.data, [currentData?.data]);
  const isWorking = isLoading || isFetching;
  const isLoadingError = isError || !id;
  const isWarrantyDetailsPage = pathname === detailPathname;
  const [trigger] = useLazyGetNewWarrantyClaimsCountQuery({
    refetchOnFocus: true,
    pollingInterval: 60 * 1000 * 5,
    refetchOnReconnect: true,
  });
  useEffect(() => {
    if (data && isSuccess) {
      trigger();
    }
  }, [trigger, data, isSuccess]);

  if (!isWarrantyDetailsPage) return null;
  return (
    <BlockContainer>
      <div className='warranty-details-block'>
        <WarrantyDetailsHeader title={title} warrantyNo={id} />
        {isLoadingError ? (
          <LoadingError />
        ) : isWorking || !data ? (
          <WarrantyDetailsLoadingSkeleton />
        ) : (
          <WarrantyClaimProvider warrantyData={data}>
            <WarrantyDetailsForm />
          </WarrantyClaimProvider>
        )}
      </div>
    </BlockContainer>
  );
};
